<template>
  <span class="client-chip" :style="{backgroundColor: color}">
    <el-avatar :src="src" :size="38" :title="userName" class="chip-avatar"></el-avatar>
    <span class="chip-content">
      <!-- eslint-disable -->
      <p v-html="$xss.process(content)"></p>
    </span>
    <mu-icon v-if="deleted" value="el-icon-close" class="chip-close" @click="deleteItem" :size="20" color="#98a3ad">
    </mu-icon>
  </span>
</template>
<script>
export default {
  props: {
    src: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "rgba(14, 24, 49, 0.5)",
    },
    content: {
      type: String,
      default: "",
    },
    deleted: {
      type: Boolean,
      default: false,
    },
    userName: {
      type: String,
      default: "",
    },
  },
  methods: {
    deleteItem() {
      this.$emit("closeClick");
    },
  },
};
</script>
<style lang="scss" scoped>
.client-chip {
  border-radius: 16px;
  position: relative;
  line-height: 30px;
  height: 30px;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  background-color: #e0e0e0;
  color: rgba(0, 0, 0, 0.87);
  box-shadow: 1px 1px 5px #ccc;
  font-size: 13px;
  padding: 0 12px;
  padding-left: 30px;
  outline: none;
  cursor: default;
  margin: 8px;

  vertical-align: middle;
  .chip-close {
    margin-left: 10px;
    cursor: pointer;
    &:hover {
      color: #ffffff !important;
    }
  }
  .el-avatar {
    background: #f5f5f5;
  }
  .el-avatar:first-child {
    margin-left: -12px;
    margin-right: 4px;
  }
  .chip-avatar {
    position: absolute;
    left: 0;
    top: -5px;
  }
  .chip-content {
    color: #ffffff;
    font-size: 12px;
    display: inline-block;
    min-width: 20px;
    max-height: 50px;
    white-space: nowrap;
    overflow: hidden;
  }
}
</style>
